import React, { useEffect } from "react";
import "./home.css";
import {
  WidgetList,
  PieChartComponent,
  BarChartComponent,
  TransactionsTable,
} from "./components";
import { Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import { getStudentStats } from "../../api/student";
import {
  STATS,
  totalSchoolFeesReceivedVsPendingData,
} from "../../util/constants";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const Home = () => {
  const { t } = useTranslation();

  const [pieChartData, setPieChartData] = useState(
    totalSchoolFeesReceivedVsPendingData
  );
  const [stats, setStats] = useState(STATS);

  const [loading, setLoading] = useState(false);

  const { token, role, schoolId } = useSelector((state) => state.user);
  let payload = {
    schoolId,
    role,
  };

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const response = await getStudentStats(payload, token);
        if (response) {
          const updatedValues = [
            response.totalStudents,
            response.studentWithoutPayments,
            response.totalReceivedTransactions,
            response.totalPaymentReceived,
            response.pendingFee,
          ];

          const updatedStats = stats.map((item, index) => {
            return { ...item, value: updatedValues[index] };
          });
          setStats(updatedStats);

          setPieChartData([
            {
              title: "Pending",
              value: response?.studentWithoutPayments,
              color: "#2E6C7C",
            },
            {
              title: "Received",
              value: response?.totalStudents - response?.studentWithoutPayments,
              color: "#82BCC0",
            },
          ]);
          setLoading(false);
        }
      } catch (err) {}
    })();
  }, []);

  return (
    <div className="home-page">
      <WidgetList loading={loading} stats={stats} />
      <Typography variant="h4" style={{ marginBottom: 20, marginTop: 20, marginLeft:"3.25vw" }}>
        {t("text_analytics")}
      </Typography>
      <div className="charts-row">
        <PieChartComponent loading={loading} pieChartData={pieChartData} />
        <BarChartComponent />
      </div>
      <div className="second-card-row">
        <TransactionsTable />
      </div>
    </div>
  );
};
